import React from 'react';

export const AgentPlatformHubRobotIcon: React.FC<{ className?: string }> = ({
  className = 'h-6 w-6',
}) => (
  <svg
    className={className}
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth={1.75}
    aria-hidden
  >
    <path strokeLinecap="round" d="M12 3v2M9 5h6" />
    <rect x="8" y="5" width="8" height="5" rx="1.5" />
    <circle cx="10" cy="7.5" r="0.75" fill="currentColor" stroke="none" />
    <circle cx="14" cy="7.5" r="0.75" fill="currentColor" stroke="none" />
    <path strokeLinecap="round" strokeLinejoin="round" d="M7 10h10v7a2 2 0 01-2 2H9a2 2 0 01-2-2v-7z" />
    <path strokeLinecap="round" d="M10 14h4M5 12H4M20 12h-1" />
  </svg>
);
